import { TaskCategory } from '@sib/api';

export const taskCategoryColors: Record<TaskCategory, string> = {
  [TaskCategory.ClientCall]: 'hsl(var(--success))',
  [TaskCategory.ClientEmail]: 'hsl(var(--accent-blue))',
  [TaskCategory.DataAnalysis]: 'hsl(var(--danger))',
  [TaskCategory.DataGathering]: 'hsl(var(--info))',
  [TaskCategory.InternalOutreach]: 'hsl(var(--warning))',
  [TaskCategory.InvoiceCollection]: 'hsl(var(--accent-blue))',
  [TaskCategory.Other]: 'hsl(var(--neutral-soft))',
  [TaskCategory.ReportBuild]: 'hsl(var(--accent-blue))',
  [TaskCategory.Research]: 'hsl(var(--danger))',
  [TaskCategory.ProactiveClientOutreach]: 'hsl(var(--warning))',
  [TaskCategory.VendorCall]: 'hsl(var(--info))',
  [TaskCategory.VendorEmail]: 'hsl(var(--success))',
};
